
import React from 'react';
import "../styles/nav.css"

const token = localStorage.getItem("token");


class NavBar extends React.Component
{
    
   
 
    
    render()
    {
        if (token === null) {
            return (
            
                <div id='Nav'>
                   
                
                <div className="nav ">
          
                      
          <a className="navbar-brand d-flex flex-row" href="/" >
                    <h3 class="text-danger pe-1 real" >Real</h3>
                    <h3 class="text-light">KBDFans</h3>
                    </a>
          <a  className="navlinks text-light" href="/login" id="1">Login</a>
        <a   className="navlinks text-light"  href="/products" id="2">Products</a>
        <a   className="navlinks text-light" href="/gallery" id="4">Gallery</a>
        <a   className="navlinks text-light" href="/profile" id="5"><i class="bi bi-person"></i></a>
       
         
    
        </div>
    
    
          </div>
          
            );
           
        }
        else  {
            return (
            
                <div id='Nav'>
                   
                
                <div className="nav">
          
                      
          <a className="navbar-brand d-flex flex-row" href="/">
                    <h3 class="text-danger pe-1">Real</h3>
                    <h3 class="text-light">KBDFans</h3>
                    </a>
        <a   className="navlinks"  href="/products" id="2">Products</a>
        <a   className="navlinks" href="/gallery" id="4">Gallery</a>
        <a   className="navlinks" href="/profile" id="5"><i class="bi bi-person"></i></a>
        <a   className="navlinks" href="/cart" id="3" ><i class="bi bi-cart"></i></a>
      
    
        </div>
    
    
          </div>
            ); 
        }
      
    }
}

export default NavBar;
